export const capitalEmployedFilterDefault = {
  Origem: null,
  StatusStock: null,
  query: null
}